import React from 'react';

import { Button, LbInput, Surface } from '@infoods/lifebase-ui';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';

import classes from './FiltersRow.module.scss';
import { CoachListFilterFormValues } from '../../../../../../interfaces/coachList/CoachListFilters';
import { GridTableRow } from '../../../../../../../shared/components/table-components';

type FiltersRowProps = {
  isMobile: boolean;
};

const FiltersRow = ({ isMobile }: FiltersRowProps) => {
  const { control, reset } = useFormContext<CoachListFilterFormValues>();

  const inputGeneralProps = { control, variant: 'outlined', size: 'small' } as const;

  const handleReset = () => {
    reset();
  };

  const filterClasses = classNames(classes.filtersRow, {
    [classes.mobileLayout]: isMobile,
  });

  return (
    <Surface variant="elevated" className={classes.container}>
      <GridTableRow variant="unstyled" customLayout={isMobile} className={filterClasses}>
        <LbInput {...inputGeneralProps} name="coachName" label="Coach Name" />
        <LbInput {...inputGeneralProps} name="entityName" label="Business Name" />
        <Button variant="outlined" fullWidth size="small" onClick={handleReset}>
          Clear All
        </Button>
      </GridTableRow>
    </Surface>
  );
};

export { FiltersRow };
